export const WHATSAPP_NUMBER = "5518996346993";
export const WHATSAPP_DISPLAY = "(18) 99634-6993";

export const waLink = (msg = "Olá, SOLLUS! Gostaria de solicitar um orçamento.") =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const NAV = [
  { label: "Página Inicial", path: "/", id: "inicio" },
  { label: "Produtos", path: "/produtos", id: "produtos" },
  { label: "Sobre a SOLLUS", path: "/sobre", id: "sobre" },
  { label: "Fale Conosco Agora", path: "/contato", id: "contato" },
];

export const INFO = {
  razao: "[Razão social oficial]",
  cnpj: "[CNPJ]",
  endereco: "Avenida do Níquel, 600 — Distrito Industrial",
  cidade: "Assis, SP — CEP 19812-040",
  email: "sollus@sollusagricola.com.br",
  telefone: "(18) 99634-6993",
  horario: "[Horário de atendimento]",
  fundacao: "1996",
  mapa: "https://www.google.com/maps/search/?api=1&query=Avenida+do+N%C3%ADquel+600+Assis+SP",
};

export const SOCIAL = [
  { id: "instagram", label: "Instagram", url: "https://instagram.com/sollusagricola.oficial/" },
  { id: "facebook", label: "Facebook", url: "https://facebook.com/Agricola.Sollus" },
  { id: "linkedin", label: "LinkedIn", url: "https://linkedin.com/company/sollus/" },
  { id: "youtube", label: "YouTube", url: "https://youtube.com/@sollus5566" },
];

export const CATEGORIES = ["Todos", "Grãos", "Cana-de-açúcar", "Distribuição", "Apoio"];

export const PRODUCTS = [
  { slug: "bazuka", name: "Bazuka", model: "Bazuka Premium 25.0", category: "Grãos", img: "/img/p-bazuka.webp",
    desc: "Carreta graneleira agrícola para agilizar o transbordo de grãos na colheita." },
  { slug: "spander", name: "Spander", model: "Spander Multi 3.0 · Flex 12.5 · 25.0 CHC-C", category: "Distribuição", img: "/img/p-spander.webp",
    desc: "Distribuidor de torta de filtro, compostos orgânicos, cama de frango, corretivos e fertilizantes granulados." },
  { slug: "plant-flex", name: "Plant Flex", model: "Plant Flex Automatic", category: "Cana-de-açúcar", img: "/img/p-plant-flex.webp",
    desc: "Plantadora de cana-de-açúcar SOLLUS." },
  { slug: "bazuka-front", name: "Bazuka Front", model: "Bazuka Front Premium 25.0", category: "Grãos", img: "/img/p-bazuka-front.webp",
    desc: "Carreta graneleira agrícola com descarga frontal." },
  { slug: "bazuka-mix", name: "Bazuka Mix", model: "Bazuka Mix", category: "Cana-de-açúcar", img: "/img/p-bazuka-mix.webp",
    desc: "Equipamento indicado para aumentar o rendimento operacional no plantio mecanizado e cultivo de cana." },
  { slug: "guincho", name: "Guincho", model: "Guincho Munk Bag 2.0", category: "Apoio", img: "/img/p-guincho.webp",
    desc: "Equipamento multifunção destinado à movimentação de cargas." },
  { slug: "apoio", name: "Linha de Apoio", model: "Fire Truck e veículos de apoio", category: "Apoio", img: "/img/p-apoio.webp",
    desc: "Linha completa de apoio, incluindo o caminhão-pipa bombeiro SOLLUS Fire Truck." },
];
